<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
        :title="page"
        icon="mdi-poll"
        :breadcrumbs="breadcrumbs"
    ></vuse-section-definition>
    <v-container fluid>
      <v-row class="mb-5">
        <v-col class="text-right" cols="12">
          <v-btn
              color="primary"
              @click="add"
          >
            Thêm
          </v-btn>
        </v-col>
      </v-row>
      <v-row align="center" class="mt-n6 " justify="center">
        <v-col cols="12">
          <v-data-table
              :headers="headers"
              :items="service"
              :items-per-page="10"
              class="elevation-1">
            <template v-slot:item.photo_url="{ item }">
              <img :src=" item.photo_url ? url + item.photo_url : require('@/assets/images/logo_Eglife1.png')"
                   width="50">
            </template>
            <template v-slot:item.active="{ item }">
              <v-switch
                  v-model="item.active"
                  class="pa-3"
                  :value="item.active"
                  @click="updateActive(item.id)"
              ></v-switch>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-icon class="mr-2" small @click="editItem(item.id)">
                mdi-pencil
              </v-icon>
              <v-icon small @click="deleteItem(item.id)"> mdi-delete</v-icon>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {DELETE_SERVICE, GET_DETAIL_SERVICE, GET_LIST_SERVICE, UPDATE_SERVICE} from "@/store/modules/service";

export default {
  name: "Service",
  data(){
    return{
      page: "Danh sách Service",
      breadcrumbs: [
        {
          text: "Trang chủ",
          disabled: true,
        },
        {
          text: "Danh sách Service",
          disabled: false,
        },
      ],
      headers: [
        {
          text: 'ID',
          align: 'start',
          value: 'id',
        },
        {text: 'Name', value: 'name'},
        {text: 'Description', value: 'description'},
        {text: 'Photo', value: 'photo_url'},
        {text: 'Display', value: 'active'},
        {text: 'Actions', value: 'actions', sortable: false},
      ],
      url: '',
      selected: -1,

    }
  },
  computed:{
    ...mapGetters({
      service:"service",
      serviceDetail:"serviceDetail"
    })
  },
  async created() {
    this.url = process.env.VUE_APP_API_URL
    await this.$store.dispatch(GET_LIST_SERVICE);
  },
  methods:{
    async updateActive(id) {
      await this.$store.dispatch(GET_DETAIL_SERVICE, id)
      this.service.forEach(item => {
        if (item.id == id) {
          this.selected = item.active == true ? 1 : 0
        }
      })
      this.serviceDetail.active = this.selected
      await this.$store.dispatch(`${UPDATE_SERVICE}`, this.serviceDetail).then((data) => {
        if (data.data.status == 1) {
          this.$toasted.success('Cập nhật thành công!', {
            duration: 1000,
            position: 'top-center'
          })
          this.$router.push('/service')
        } else {
          alert(data.data.errors)
        }
      });
    },
    deleteItem(id) {
      confirm('Bạn có chắc chắn muốn xóa không ?') &&
      this.$store.dispatch(`${DELETE_SERVICE}`, id).then(data => {
        if (data && data.status === 1) {
          this.$store.dispatch(GET_LIST_SERVICE);
        }
      })
    },
    editItem(id) {
      this.$router.push({
        path: "/service/edit_service/" + id,
      });
    },
    add(){
      this.$router.push('/service/add_service')
    }
  }
}
</script>

<style scoped>

</style>